export default __webpack_public_path__ + "static/media/user-avatar.6a381683.png";